import { Spin } from "antd";
import { Field, Form, FormikProvider, useFormik } from "formik";
import React from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import swal from "sweetalert";
import {
  GET_GSTPlansDropDownList,
  POST_CompanyUpdate,
  POST_GetCompanyDetailByID,
} from "../../../helpers/url_helper";
import { useEffect } from "react";
import { get, post, postFormData } from "../../../helpers/api_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  validateEmailField,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";

const CompanyParameters = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [country, setCountry] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyLogoFile, setCompanyLogoFile] = useState(null);

  const validationSchema = Yup.object().shape({
    CompanyName: Yup.string().trim().required("Company Name is required field"),
    MobileNo: Yup.string().trim().required("Mobile No is required field"),
    EmailID: Yup.string().trim().required("EmailID is required field"),
    GSTNo: Yup.string().trim().required("GST No is required field"),
    GSTPlanIDEncrypted: Yup.string()
      .trim()
      .required("GST(%) is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CompanyIDEncrypt: "",
      CompanyName: "",
      CompanyAddress: "",
      Pincode: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      EmailID: "",
      CompanyLogo: "",
      AppVersion: "",
      DBVersion: "",
      GSTNo: "",
      PANNo: "",
      MSMENo: "",
      CityName: "",
      StateName: "",
      CountryName: "",
      NABLLabCertificateNo: "",
      GSTPlanIDEncrypted: "",
      NABLScopeURL: "",
      ReportDocumentNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { CountryCode },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo,
      )
    ) {
      formik.setFieldError("MobileNo", "Please enter a valid mobile number");
      formik.setFieldTouched("MobileNo", true);
      return false;
    }

    if (values?.NABLScopeURL) {
      if (!isValidURL(values?.NABLScopeURL)) {
        formik.setFieldError(
          "NABLScopeURL",
          "Please enter a valid NABL Scope URL",
        );
        formik.setFieldTouched("NABLScopeURL", true);
        return false;
      }
    }

    setIsLoading(true);
    let formData = new FormData();
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("CompanyName", values?.CompanyName);
    formData.append("CompanyAddress", values?.CompanyAddress);
    formData.append("CityName", values?.CityName);
    formData.append("StateName", values?.StateName);
    formData.append("CountryName", values?.CountryName);
    formData.append("Pincode", values?.Pincode);
    formData.append(
      "CountryCode",
      "+" + values?.CountryCode.replace(/\+/g, ""),
    );
    formData.append("MobileNo", values?.MobileNo);
    formData.append("EmailID", values?.EmailID);
    formData.append("CompanyLogoUrl", values?.CompanyLogo);
    formData.append("GSTNo", values?.GSTNo);
    formData.append("PANNo", values?.PANNo);
    formData.append("MSMENo", values?.MSMENo);
    formData.append("NABLScopeURL", values?.NABLScopeURL);
    formData.append("ReportDocumentNo", values?.ReportDocumentNo);

    formData.append(
      "ModifiedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append("CompanyLogo", companyLogoFile);
    formData.append("NABLLabCertificateNo", values?.NABLLabCertificateNo);
    formData.append("GSTPlanIDEncrypted", values?.GSTPlanIDEncrypted);

    postFormData(POST_CompanyUpdate, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadCompanyLogo = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setCompanyLogoFile(null);
        setCompanyLogo(null);
        //  swal("", "Select valid image file!", "warning");
        warningMessage("Select valid image file!");
      } else {
        // var reader = new FileReader();
        // reader.readAsDataURL(e.target.files[0]);
        // reader.onload = function (e) {
        //   var image = new Image();
        //   image.src = e.target.result;
        //   image.onload = function () {
        //     var height = this.height;
        //     var width = this.width;
        // if (height !== 200 || width !== 200) {
        //   swal("Error!", "Image size must be of 200x120", "error");
        //   setCompanyLogoFile(null);
        //   setCompanyLogo(null);
        // } else {
        setCompanyLogoFile(file);
        setCompanyLogo(URL.createObjectURL(file));
        // }
        //   };
        // };
      }
    }
  };

  const getCompanyDetails = () => {
    setIsLoading(true);
    post(POST_GetCompanyDetailByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({ ...response });
          setCompanyLogo(response.CompanyLogo);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    get_GSTPlans();
    getCompanyDetails();
  }, []);

  const [gstPlanOptions, setGSTPlanOptions] = useState([]);

  const get_GSTPlans = async () => {
    setIsLoading(true);
    await get(GET_GSTPlansDropDownList)
      .then((response) => {
        setGSTPlanOptions(
          response?.GSTPlanList?.map((item) => ({
            label: item.GSTPlan,
            value: item.GSTPlanIDEncrypted,
            GSTPercentage: item.GSTPercentage,
          })),
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function isValidURL(url) {
    // const regex =
    //   /^(https?:\/\/)?(([0-9]{1,3}\.){3}[0-9]{1,3}|([\da-z.-]+)\.([a-z.]{2,6}))(:\d+)?(\/[\/\w .-]*)*\/?$/;
    const regex = /^https?:\/\/.*/;
    return regex.test(url);
  }

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Company Information</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Company Name"
                      name="CompanyName"
                      placeholder={"Enter Company Name"}
                      component={CustomInput}
                      required
                      maxLength={250}
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "CompanyName",
                          capitalizeString(e?.target?.value),
                        );
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Mobile No."
                      name="MobileNo"
                      placeholder={"Enter Mobile No."}
                      country={country}
                      countryCode={CountryCode}
                      component={CustomPhoneInput}
                      onChange={(value, { countryCode, dialCode }) => {
                        formik.setFieldValue("CountryCode", dialCode);
                        formik.setFieldValue(
                          "MobileNo",
                          value.substring(dialCode.toString().length),
                        );
                      }}
                      onFocus={(value, { format }) => {
                        formik.setFieldValue("MobileNoFormat", format);
                      }}
                      required
                    />
                  </Col>

                  <Col lg={3}>
                    <Field
                      type="email"
                      label="Email"
                      name="EmailID"
                      placeholder={"Enter Email"}
                      component={CustomInput}
                      maxLength={100}
                      required
                      validate={validateEmailField}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="GST No."
                      name="GSTNo"
                      placeholder={"Enter GST No."}
                      component={CustomInput}
                      maxLength={50}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={9}>
                    <Row>
                      <Col lg={4}>
                        <Field
                          label="Address"
                          name="CompanyAddress"
                          rows={5}
                          placeholder={"Enter Address"}
                          component={CustomTextArea}
                          maxLength={500}
                        />
                      </Col>
                      <Col lg={8}>
                        <Row>
                          <Col lg={6}>
                            <Field
                              label="Pincode"
                              name="Pincode"
                              placeholder={"Enter Pincode"}
                              component={CustomInput}
                              maxLength={10}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="City"
                              name="CityName"
                              placeholder={"Enter City"}
                              component={CustomInput}
                              maxLength={100}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "CityName",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="State"
                              name="StateName"
                              placeholder={"Enter State"}
                              component={CustomInput}
                              maxLength={100}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "StateName",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Country"
                              name="CountryName"
                              placeholder={"Enter Country"}
                              component={CustomInput}
                              maxLength={100}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "CountryName",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">
                      Company Logo (200 x 200)
                      {/* <span className="text-danger">*</span>*/}
                      {/* {" "}
                      <span className="text-danger fs-12">(200 x 200)</span> */}
                    </label>
                    {/* <div className="image-placeholder companyLogo-placeholder"> */}
                    <div className="image-placeholder square-placeholder">
                      <div className="avatar-edit">
                        <input
                          type="file"
                          id="imageUpload"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadCompanyLogo}
                        />
                        <label htmlFor="imageUpload" name=""></label>
                      </div>
                      <div
                        id="removeFile"
                        className="avatar-delete"
                        onClick={() => {
                          setCompanyLogoFile(null);
                          setCompanyLogo(null);
                          formik.setFieldValue("CompanyLogo", "");
                        }}
                      >
                        <label htmlFor="removeFile" name=""></label>
                      </div>
                      <div className="avatar-preview">
                        <div id="imagePreview">
                          <img
                            id="saveImageFile"
                            src={companyLogo ? companyLogo : img200}
                            alt={"Company Logo"}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="PAN No."
                      name="PANNo"
                      placeholder={"Enter PAN No."}
                      component={CustomInput}
                      maxLength={50}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "PANNo",
                          capitalizeString(e?.target?.value),
                        );
                      }}
                    />
                  </Col>
                  {/* <Col lg={3}>
                    <Field
                      label="NABL Lab Certificate No"
                      name="NABLLabCertificateNo"
                      placeholder={"Enter NABL Lab Certificate No"}
                      component={CustomInput}
                      maxLength={10}
                    />
                  </Col> */}
                  <Col lg={3}>
                    <Field
                      label="NABL Scope URL"
                      name="NABLScopeURL"
                      placeholder={"Enter NABL Scope URL"}
                      component={CustomInput}
                      maxLength={500}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="GST(%)"
                      name="GSTPlanIDEncrypted"
                      component={CustomSelect}
                      options={gstPlanOptions}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="MSME No."
                      name="MSMENo"
                      placeholder={"Enter MSME No."}
                      component={CustomInput}
                      maxLength={50}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Report Document No"
                      name="ReportDocumentNo"
                      placeholder={"Enter Report Document No."}
                      component={CustomInput}
                      maxLength={50}
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm me-2"
                  onClick={(e) => {
                    navigate("/dashboard");
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default CompanyParameters;
